import React from 'react'
import { Typography, Box } from '@mui/material'
import AppModal from '../common/AppModal'
import OpenShiftForm from '../../forms/OpenShiftForm'

interface OpenShiftModalProps {
  open: boolean
  onClose: () => void
  loading: boolean
  error: string | null
}

const OpenShiftModal: React.FC<OpenShiftModalProps> = ({ open, onClose, loading, error }) => (
  <AppModal open={open} onClose={onClose} title="Open Register Shift" width="sm" loading={loading}>
    <Box sx={{ mb: 2 }}>
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        Enter the starting cash float in the till before processing any sales.
      </Typography>
    </Box>
    <OpenShiftForm loading={loading} error={error} />
  </AppModal>
)

export default OpenShiftModal
